import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** https://jira.vk.team/browse/CLOUDWEB-18375 Заменить иконки в разных типах редактора на разноцветные. */
export const IS_DOCUMENTS_ICONS_REDESIGN_ENABLED = isFeature('is_documents_icons_redesign_enabled');
